<template>
    <b-card no-body>
      <!-- <template v-slot:header>
        <LoadingButton :loading="adding_campaign_loading" @click="add_campaign" class="float-right">Add campaign</LoadingButton>
      </template> -->

      <b-table :items="items" :fields="fields">
        <template v-slot:cell(actions)='data'>
          <LoadingButton :loading="checking_campaign_loading" @click="check_campaign(data.item)">Check status</LoadingButton>
        </template>

        <template v-slot:cell(submission_date)='data'>
          <span v-if="data.item.detail">{{data.item.detail.submission_date}}</span>
        </template>

        <template v-slot:cell(purchase_date)='data'>
          <span v-if="data.item.detail">{{data.item.detail.purchase_date}}</span>
        </template>

        <template v-slot:cell(paid)='data'>
          <span v-if="data.item.detail">{{data.item.detail.paid}}</span>
        </template>

        <template v-slot:cell(package_id)='data'>
          <span v-if="data.item.detail">{{data.item.detail.package_id}}</span>
        </template>

        <template v-slot:cell(password)='data'>
          <span v-if="data.item.detail">{{data.item.detail.password}}</span>
        </template>

        <template v-slot:cell(completion_date)='data'>
          <span v-if="data.item.detail">{{data.item.detail.completion_date}}</span>
        </template>

        <template v-slot:cell(specialist_info)='data'>
          <span v-if="data.item.detail">{{data.item.detail.specialist_info}}</span>
        </template>

        <template v-slot:cell(created)='data'>
          {{data.item.created | date}}
        </template>

        <template v-slot:cell(updated)='data'>
          {{data.item.updated | date}}
        </template>
      </b-table>
    </b-card>
</template>

<script>

import { db } from '@/main.js'
import ItemMixin from '@/mixins/Item.js'
import api from '@/lib/api.js'

export default {
  name: 'campaigns',
  mixins: [ItemMixin],
  firestore: function () {
    return {
      items: db.collection('site').doc(this.$route.params.site_id).collection('location').doc(this.$route.params.id).collection(this.collection).orderBy('created', 'desc')
    }
  },
  data() {
    return {
      items: [],
      checking_campaign_loading: false,
      adding_campaign_loading: false,
      collection: 'campaign',
      fields: [
        {key: 'created'},
        {key: 'updated'},
        {key: 'campaign_id'},
        // {key: 'submission_date'},
        // {key: 'purchase_date'},
        // {key: 'paid'},
        // {key: 'password'},
        // {key: 'specialist_info'},
        {key: 'package_id'},
        {key: 'completion_date'},
        {key: 'actions'}
      ]
    }
  },
  methods: {
    async check_campaign(campaign) {
      this.checking_campaign_loading = true
      let result = await api.check_campaign(this.$route.params.site_id, this.$route.params.id, campaign.campaign_id, campaign.id)
      this.checking_campaign_loading = false
      console.log(result)
    },
    async add_campaign() {
      this.adding_campaign_loading = true
      let result = await api.add_campaign(this.$route.params.site_id, this.$route.params.id)
      this.adding_campaign_loading = false
      console.log(result)
    },
  },
  metaInfo() {
    return {
      title: `${this.collection}s`
    };
  },
}
</script>

<style>

</style>
